export default __webpack_public_path__ + "static/media/fitness.e00f0895.png";